import {isNullOrUndefined} from 'util';

interface LabelValue {
  label: string;
  value: any;
}

type LabelValueCallback<T> = (item: T) => LabelValue;

export const buildSelectItemsFor = (items: any[], propertyName: string, valueProperty: string = null): any[] => {
  const itemList = [];
  items.forEach((item) => {
    let value = item;

    if (!isNullOrUndefined(valueProperty) && Object.keys(item).includes(valueProperty)) {
      value = item[valueProperty];
    }

    itemList.push({label: item[propertyName], value});
  });
  return itemList;
};

export const buildSelectItemsBy = <T>(items: T[], labelValueFactory: LabelValueCallback<T>): any[] => {
  const itemList = [];
  items.forEach((item) => {
    const labelValueInfo = labelValueFactory(item);
    itemList.push({label: labelValueInfo.label, value: labelValueInfo.value});
  });
  return itemList;
};

export const getDirtyFormValues = (form: any) => {
  let dirtyValues = {};

  Object.keys(form.controls)
    .forEach(key => {
      let currentControl = form.controls[key];

      if (currentControl.dirty) {
         dirtyValues[key] = currentControl.value;
      }
    });

  return dirtyValues;
};


// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/utils/form-utils.ts